import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from 'recharts';
import type { FunnelStage } from '@recruitai/shared';

interface FunnelChartProps {
  data: FunnelStage[];
}

const COLORS: Record<string, string> = {
  pending: '#94a3b8',
  analyzing: '#60a5fa',
  approved: '#34d399',
  rejected: '#f87171',
  interviewed: '#a78bfa',
  hired: '#fbbf24',
};

export function FunnelChart({ data }: FunnelChartProps) {
  return (
    <div className="bg-white rounded-lg border p-4">
      <h3 className="text-sm font-medium text-gray-700 mb-3">Funil de Candidatos</h3>
      <ResponsiveContainer width="100%" height={250}>
        <BarChart data={data} layout="vertical">
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis type="number" tick={{ fontSize: 11 }} />
          <YAxis dataKey="status" type="category" tick={{ fontSize: 11 }} width={90} />
          <Tooltip formatter={(value: number, _name: string, props: any) => [`${value} (${props.payload.percentage}%)`, 'Candidatos']} />
          <Bar dataKey="count" radius={[0, 4, 4, 0]}>
            {data.map((entry) => (
              <Cell key={entry.status} fill={COLORS[entry.status] || '#94a3b8'} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
